import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Button, Tab } from "@mui/material";
import { Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import ContactForm from "./components/contact-form.tsx";
import NotificationForm from "./components/notification-form.tsx";
import PerformanceForm from "./components/performance-form.tsx";
import PersonalForm from "./components/personal-form.tsx";
import ProfileForm from "./components/profile-form.tsx";
import RatesForm from "./components/rates-form.tsx";

interface Props {
    id?: number;
    initialTab?: string;
}

export default function StaffForm({ id, initialTab }: Props) {
    const [activeTab, setActiveTab] = useState(initialTab ?? "contact");

    const [onSaveAction, setOnSaveAction] = useState<() => Promise<unknown>>();

    const navigate = useNavigate();

    const handleSave = async () => {
        await onSaveAction?.();
    };

    const handleChangeTab = (tab: string) => {
        setActiveTab(tab);
        void navigate({ to: ".", search: { tab } });
    };

    const onSaveSetter = (onSave: () => Promise<unknown>) => setOnSaveAction(() => onSave);

    return (
        <>
            <TabContext value={activeTab}>
                <TabList onChange={(_e, value) => handleChangeTab(value)}>
                    <Tab value={"contact"} label={"Contact"} />
                    {id != undefined && [
                        <Tab key={0} value={"personal"} label={"Personal"} />,
                        <Tab key={1} value={"profile"} label={"Profile"} />,
                        <Tab key={2} value={"rates"} label={"Rates"} />,
                        <Tab key={3} value={"performance"} label={"Performance"} />,
                    ]}
                    <Tab value={"notifications"} label={"Notifications"} />
                </TabList>
                <TabPanel value={"contact"}>
                    <ContactForm id={id} setOnSave={onSaveSetter} />
                </TabPanel>
                <TabPanel value={"personal"}>
                    <PersonalForm id={id} setOnSave={onSaveSetter} />
                </TabPanel>
                <TabPanel value={"profile"}>
                    <ProfileForm id={id} setOnSave={onSaveSetter} />
                </TabPanel>
                <TabPanel value={"rates"}>
                    <RatesForm id={id} setOnSave={onSaveSetter} />
                </TabPanel>
                <TabPanel value={"performance"}>
                    <PerformanceForm id={id} setOnSave={onSaveSetter} />
                </TabPanel>
                <TabPanel value={"notifications"}>
                    <NotificationForm id={id} setOnSave={onSaveSetter} />
                </TabPanel>
            </TabContext>
            <Box display={"flex"} gap={1}>
                <Link to={".."}>
                    <Button variant={"outlined"}>Cancel</Button>
                </Link>
                <Button variant={"contained"} onClick={handleSave}>
                    Save
                </Button>
            </Box>
        </>
    );
}
